/**
 * This front-end-render component serves for the `screen`.
 * As the PRD and the Boss, the 4th and 5th should be rendered
 * by front-end. As a compability of IE 8, we are likely to
 * render the screen at server side, and React would take over
 * these screens and re-render them.
 *
 * As batch apis' require, we would request 10 regions in one
 * batch request, witch means we should combine these data in
 * a HOC.
 *
 *  Server side
 *
 *      <Page>
 *          <Other Components />
 *          <TargetScreen />
 *          <Other Components />
 *      </Page>
 *
 *  FrontEnd side
 *
 *      ...Normal HTMLs (pure string)
 *      <#front-root>
 *          <ScreenWrapper>
 *              <targetScreen />
 *          </ScreenWrapper>
 *      </#front-root>
 *      ...Normal HTMLs (pure string)
 *
 * Note: Beware that we are likely to rerender ad components at the
 * same time. Make sure the compability of the ad sdk, especially
 * when ssr node was removed.
 * @summary Including SingleScreen & ScreenWrapper
 * @author MonkeyFigaro <monkeychen@sohu-inc.com>
 *
 * Created at     : 2019-08-19 10:30:54
 * Last modified  : 2019-08-22 15:08:46
 */

import React, {  } from 'react';
import s from '../../pages/HomePageStatic/HomePage.scss';
import { CategoryCard, CategoryConfig } from '../HomeTop/CategoryCard';
import { EnumCard, EnumConfig } from '../HomeTop/EnumCard';
import { RecommendCard, RecommendConfig } from '../HomeTop/RecommendCard';
import { GodBox } from '../AdGod';
import { AdConfig } from '../AdGod/GodBox';

export interface SingleScreenConfigs {
    channelConfigs: CategoryConfig[],
    enumConfigs: EnumConfig[],
    recommendConfigs: RecommendConfig[],
    rectAdConfig: AdConfig[],
    longAdConfig?: AdConfig[],
}

export const SingleScreen = (props: SingleScreenConfigs) => {
    const { channelConfigs, enumConfigs, recommendConfigs, rectAdConfig, longAdConfig = [] } = props;
    // tslint:disable: no-console
    if (channelConfigs.length !== 4) { console.error(`A single screen component needs 4 channels but got ${channelConfigs.length} !`); }
    if (enumConfigs.length !== 4) { console.error(`A single screen component needs 4 enumConfigs but got ${enumConfigs.length} !`); }
    if (recommendConfigs.length !== 4) { console.error(`A single screen component needs 4 recommend cards but got ${recommendConfigs.length} !`); }
    // tslint:enable: no-console
    return (
        <>
            <div className={s.row}>
                <div className={s.leftBox}>
                    <div className={s.section}>
                        {channelConfigs[0] ? <CategoryCard showLoading={true} {...channelConfigs[0]} /> : null }
                        {enumConfigs[0] ? <EnumCard {...enumConfigs[0]} /> : null }
                        {channelConfigs[1] ? <CategoryCard showLoading={true} {...channelConfigs[1]} /> : null }
                        {enumConfigs[1] ? <EnumCard {...enumConfigs[1]} /> : null }
                    </div>
                    <div className={s.section}>
                        {channelConfigs[2] ? <CategoryCard showLoading={true} {...channelConfigs[2]} /> : null }
                        {enumConfigs[2] ? <EnumCard {...enumConfigs[2]} /> : null }
                        {channelConfigs[3] ? <CategoryCard showLoading={true} {...channelConfigs[3]} /> : null }
                        {enumConfigs[3] ? <EnumCard {...enumConfigs[3]} /> : null }
                    </div>
                </div>
                <div className={s.rightBox} >
                    <div style={{height: 672, backgroundColor: '#fff'}}>
                        {recommendConfigs[0] ? <RecommendCard {...recommendConfigs[0]} /> : <p>Loading</p>}
                        {recommendConfigs[1] ? <RecommendCard {...recommendConfigs[1]} /> : <p>Loading</p>}
                        {recommendConfigs[2] ? <RecommendCard {...recommendConfigs[2]} /> : <p>Loading</p>}
                        {recommendConfigs[3] ? <RecommendCard {...recommendConfigs[3]} style={{ paddingBottom: 40 }} /> : <p>Loading</p>}
                    </div>
                    {
                        rectAdConfig.length
                            ? <GodBox {...rectAdConfig[0]} />
                            : null
                    }
                </div>
            </div>
            {
                longAdConfig.length ? <GodBox {...longAdConfig[0]} /> : null // 时尚上面广告位
            }
        </>
    );
};



// WEBPACK FOOTER //
// ./src/components/SingleScreen/index.tsx